var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg22Mail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 18.5625H8.875C7.20911 18.5625 5.61145 19.2144 4.43349 20.3748C3.25552 21.5352 2.59375 23.109 2.59375 24.75V57.75C2.59375 59.391 3.25552 60.9648 4.43349 62.1252C5.61145 63.2856 7.20911 63.9375 8.875 63.9375H59.125C60.7909 63.9375 62.3886 63.2856 63.5665 62.1252C64.7445 60.9648 65.4062 59.391 65.4062 57.75V24.75C65.4062 23.109 64.7445 21.5352 63.5665 20.3748C62.3886 19.2144 60.7909 18.5625 59.125 18.5625H54.9375",
    stroke: "#D97517",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 20.625L34 43.3125L63.3125 20.625",
    stroke: "#D97517",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 61.875L27.7188 39.1875",
    stroke: "#D97517",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3125 61.875L40.2812 39.1875",
    stroke: "#D97517",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9375 26.8125V4.125C54.9375 3.57799 54.7169 3.05339 54.3243 2.66659C53.9316 2.2798 53.399 2.0625 52.8438 2.0625H15.1562C14.601 2.0625 14.0684 2.2798 13.6757 2.66659C13.2831 3.05339 13.0625 3.57799 13.0625 4.125V26.8125",
    stroke: "#D97517",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 20.625L29.8125 24.75L42.375 12.375",
    stroke: "#D97517",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg22Mail);
export default __webpack_public_path__ + "static/media/22-Mail.2056b2f1215349b875a944235a0e143c.svg";
export { ForwardRef as ReactComponent };